// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__7SlN8","empty":"ModalGraph_empty__1oji8"};